module.exports = __webpack_public_path__ + "img/kolase1.991aba6a.jpg";